<article class="mb-[12.8rem]">
  <app-breadcrumb [items]="['HEADER_LIST_SUBSCRIPTIONS' | translate]"></app-breadcrumb>
  <section class="flex flex-col sm:gap-[2rem] gap-[3rem]" aria-labelledby="subscriptions-heading">
    <div class="flex flex-col md:flex-row max-sm:gap-4 sm:justify-between w-full md:items-center sm:px-[9.6rem] px-[7rem]">
      <h1 id="subscriptions-heading" class="dsr-typescale-title-medium">
        {{ "HEADER_LIST_SUBSCRIPTIONS" | translate }}
      </h1>
      <div class="sm:!h-[4rem] flex">
        <mat-button-toggle-group class="!rounded-full !overflow-hidden" name="offerVariant" aria-label="Offer Variant"
          id="selOfferValue" [(ngModel)]="selectedVariant" (change)="changeSelectedVariant($event)"
          [disabled]="isVariantToggleDisabled()">
          @for (variant of variantList; track variant; let i = $index) {
            <mat-button-toggle [checked]="variant.code === selectedVariant"
              [value]="variant.code"
              class="flex-1 flex items-center justify-center h-full transition-colors max-sm:!h-[6rem]">
            <span class="sm:hidden break-all" [ngClass]="{
                  'dsr-typescale-body-small': variant.code !== selectedVariant,
                  'dsr-typescale-body-small-prominent':
                    variant.code === selectedVariant,
                }">
                {{ variant.label | translate }}
              </span>
            <span class="dsr-typescale-body-small break-all hidden sm:inline" [ngClass]="{
                  'dsr-typescale-body-small': variant.code !== selectedVariant,
                  'dsr-typescale-body-small-prominent':
                    variant.code === selectedVariant,
                }">{{ variant.label | translate }}</span>
            </mat-button-toggle>
          }
        </mat-button-toggle-group>
      </div>
    </div>

    @if(showDocSubs) {
      <div class="sm:px-[9.6rem] px-[7rem]">
        <span class="dsr-typescale-body-small required-label">
        {{ "DATE_DISCLAIMER" | translate }}</span>
      </div>
    }

    <div class="sm:px-[9.6rem]  min-h-fit !h-full ">
      <div class="!overflow-y-hidden !overflow-x-auto">
        <div class="h-[60vh] overflow-y-auto ">
          @if(showDocSubs) {
            <table mat-table   [dataSource]="docSubResponse"
              class="min-w-full mt-[1.6rem] !leading-[2.4rem]" aria-labelledby="subscriptions-table-caption">
              <caption id="subscriptions-table-caption" class="sr-only">List of subscriptions with details</caption>
              <ng-container matColumnDef="variantOfferId">
                <th mat-header-cell *matHeaderCellDef
                  class="text-center w-[8%] dsr-typescale-label-large-prominent max-sm:px-[2rem]">
                  {{ "SUBSCRIPTIONS_TABLE_HEAD_OFFER_ID" | translate }}
                </th>
                <td mat-cell *matCellDef="let item"
                  class="text-center first-letter:uppercase dsr-typescale-body-small max-sm:px-[2rem]">
                  {{ item.variantOfferId }}
                </td>
              </ng-container>
              <ng-container matColumnDef="variantOfferName">
                <th mat-header-cell *matHeaderCellDef
                  class="text-center  dsr-typescale-label-large-prominent max-sm:px-[2rem]">
                  {{ "SUBSCRIPTIONS_TABLE_HEAD_OFFER_VARIANT" | translate }}
                </th>
                <td mat-cell *matCellDef="let item"
                  class="text-center first-letter:uppercase dsr-typescale-body-small max-sm:px-[2rem]">
                  {{ item.variantOfferName }}
                </td>
              </ng-container>
              <ng-container matColumnDef="documents">
                <th mat-header-cell *matHeaderCellDef
                  class="text-center w-[10.5%] dsr-typescale-label-large-prominent max-sm:px-[2rem]">
                  {{ "SUBSCRIPTIONS_TABLE_HEAD_DOCUMENTS" | translate }}
                </th>
                <td mat-cell *matCellDef="let item" class="first-letter:uppercase font-renault-group-bold dsr-typescale-body-small">
                  <div class="flex font-renault-group-bold gap-[0.8rem]">
                    {{ item.documents | translate }}
                    <dsr-icon name="information-bubble" size="2.4rem" color="black" style="left: 40%; position: relative"
                      [ngClass]="{ hidden: item.documentTypeList.length === 0 }"
                      [matTooltip]="getDocumentTooltip(item.documentTypeList)"
                      [matTooltipDisabled]="item.documentTypeList.length === 0"
                      matTooltipClass="subscriptions-doc-tooltip" matTooltipPosition="below"></dsr-icon>
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="durationType">
                <th mat-header-cell *matHeaderCellDef
                  class="text-center 8 dsr-typescale-label-large-prominent max-sm:px-[2rem]">
                  {{ "SUBSCRIPTIONS_TABLE_HEAD_TYPE" | translate }}
                </th>
                <td mat-cell *matCellDef="let item"
                  class="text-center first-letter:uppercase dsr-typescale-body-small max-sm:px-[2rem]">
                  {{ item.durationType }}
                </td>
              </ng-container>
              <ng-container matColumnDef="price">
                <th mat-header-cell *matHeaderCellDef
                  class="text-center w-[8%] dsr-typescale-label-large-prominent max-sm:px-[2rem]">
                  {{ "SUBSCRIPTIONS_TABLE_HEAD_PRICE" | translate }}
                </th>
                <td mat-cell *matCellDef="let item"
                  class="text-center first-letter:uppercase dsr-typescale-body-small max-sm:px-[2rem]">
                  {{ item.price }}@if(item.price) {
                  <span>€</span>
                  }
                  @if(item.price == null) {
                  <span>-</span>
                  }
                </td>
              </ng-container>
              <ng-container matColumnDef="purchaseDate">
                <th mat-header-cell *matHeaderCellDef
                  class="text-center w-[13%] dsr-typescale-label-large-prominent max-sm:px-[2rem] required-label-r">
                  {{ "SUBSCRIPTIONS_TABLE_HEAD_START_DATE" | translate }}
                </th>
                <td mat-cell *matCellDef="let item"
                  class="text-center first-letter:uppercase dsr-typescale-body-small max-sm:px-[2rem]">
                  {{ item.purchaseDate }}@if(item.purchaseDate) {
                  <span>&nbsp;CET</span>
                  }
                  @if(item.purchaseDate == null) {
                  <span>-</span>
                  }
                </td>
              </ng-container>
              <ng-container matColumnDef="offerEndDate">
                <th mat-header-cell *matHeaderCellDef
                  class="text-center w-[13%] dsr-typescale-label-large-prominent max-sm:px-[2rem] required-label-r">
                  {{ "SUBSCRIPTIONS_TABLE_HEAD_END_DATE" | translate }}
                </th>
                <td mat-cell *matCellDef="let item"
                  class="text-center first-letter:uppercase dsr-typescale-body-small max-sm:px-[2rem]">
                  {{ item.offerEndDate }}@if(item.offerEndDate) {
                  <span>&nbsp;CET</span>
                  }
                  @if(item.offerEndDate == null) {
                  <span>-</span>
                  }
                </td>
              </ng-container>
              <ng-container matColumnDef="invoiceNumber">
                <th mat-header-cell *matHeaderCellDef
                  class="text-center  dsr-typescale-label-large-prominent max-sm:px-[2rem]">
                  {{ "SUBSCRIPTIONS_TABLE_HEAD_INVOICE_NO" | translate }}
                </th>
                <td mat-cell *matCellDef="let item"
                  class="">
                  <div class="text-center first-letter:uppercase dsr-typescale-body-small max-sm:px-[2rem] break-all ">
                    {{ item.invoiceNumber }}@if(item.invoiceNumber == null) {
                    <span>-</span>
                    }
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="invoiceDate">
                <th mat-header-cell *matHeaderCellDef
                  class="text-center  dsr-typescale-label-large-prominent max-sm:px-[2rem]">
                  {{ "SUBSCRIPTIONS_TABLE_HEAD_INVOICE_DATE" | translate }}
                </th>
                <td mat-cell *matCellDef="let item"
                  class="">
                  <div class="text-center first-letter:uppercase dsr-typescale-body-small max-sm:px-[2rem] break-all">
                    {{ item.invoiceDate }}@if(item.invoiceDate) {
                    <span>&nbsp;CET</span>
                    }
                    @if(item.invoiceDate == null) {
                    <span>-</span>
                    }
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="paymentStatus">
                <th mat-header-cell *matHeaderCellDef
                  class="w-[11%]">
                  <div class="text-center  dsr-typescale-label-large-prominent max-sm:px-[2rem]">{{ "SUBSCRIPTIONS_TABLE_HEAD_STATUS" | translate }}</div>
                </th>
                <td mat-cell *matCellDef="let item" class="">
                  <div class="text-center first-letter:uppercase dsr-typescale-body-small">
        
                    @if(item.paymentStatus == null) {
                      <span>-</span>
                    } @else {
                      <mat-chip [ngClass]="getPaymentStatusClass(item.paymentStatus)">
                    {{ item.paymentStatus | translate }}</mat-chip>
                    }
                  </div>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="docDisplayedColumns; sticky: true"
                class=" text-center first-letter:uppercase border-black"></tr>
              <tr mat-row *matRowDef="let row; columns: docDisplayedColumns"
                class="text-center first-letter:uppercase dsr-typescale-body-small"></tr>
              <tr *matNoDataRow class="">
                <td [attr.colspan]="docDisplayedColumns.length" class="text-center">
                  <div class="flex flex-col items-center py-4 text-light-dsr-color-secondary-container justify-end gap-[0.2rem]">
                    <svg width="17" height="21" viewBox="0 0 17 21" fill="currentColor" xmlns="http://www.w3.org/2000/svg"
                      alt="No-data found" class="button-icon !size-[40px]">
                      <path
                        d="M1.2 1.195H7.425V5.45H11.63V9.58H12.83V4L12.7 3.835C11.02 1.71 9.13 0.195 9.05 0.13L8.885 0H0V17.175H6.75V15.975H1.2V1.195ZM11.49 4.25H8.625V1.335C9.175 1.81 10.36 2.88 11.49 4.25ZM9.625 8.59H5.195V7.39H9.625V8.59ZM4.37 8.14C4.37 8.48 4.095 8.76 3.75 8.76H3.49C3.15 8.76 2.87 8.485 2.87 8.14V7.88C2.87 7.54 3.145 7.26 3.49 7.26H3.75C4.09 7.26 4.37 7.535 4.37 7.88V8.14ZM4.37 10.28C4.37 10.61 4.1 10.88 3.77 10.88H3.515C3.185 10.88 2.915 10.61 2.915 10.28V10.025C2.915 9.695 3.185 9.425 3.515 9.425H3.77C4.1 9.425 4.37 9.695 4.37 10.025V10.28ZM4.37 12.105V12.36C4.37 12.69 4.1 12.96 3.77 12.96H3.515C3.185 12.96 2.915 12.69 2.915 12.36V12.105C2.915 11.775 3.185 11.505 3.515 11.505H3.77C4.1 11.505 4.37 11.775 4.37 12.105ZM9.595 9.56V10.235L9.445 10.265C9.325 10.29 9.21 10.32 9.11 10.355C8.725 10.54 8.445 10.775 8.445 10.775H5.2V9.56H9.595ZM7.315 11.97C7.04 12.375 6.92 12.845 6.91 12.87C6.91 12.87 6.88 12.87 6.875 12.87H5.195V11.745H5.77L7.57 11.74L7.31 11.97H7.315ZM12.73 10.7H11.82C9.475 10.7 7.57 12.605 7.57 14.95V15.86C7.57 18.205 9.475 20.11 11.82 20.11H12.73C15.075 20.11 16.98 18.205 16.98 15.86V14.95C16.98 12.605 15.075 10.7 12.73 10.7ZM15.78 15.86C15.78 17.54 14.415 18.91 12.73 18.91H11.82C10.14 18.91 8.77 17.54 8.77 15.86V14.95C8.77 13.27 10.135 11.9 11.82 11.9H12.73C14.41 11.9 15.78 13.27 15.78 14.95V15.86Z"
                        fill="currentColor" />
                        <path
                          d="M11.0352 17.6289H9.91016L11.7282 15.3249L10.0452 13.1829H11.2422L12.3762 14.6319L13.5012 13.1829H14.6352L12.9342 15.3429L14.7252 17.6289H13.5282L12.2772 16.0359L11.0352 17.6289Z"
                          fill="currentColor" />
                    </svg>
                    <span class="dsr-typescale-body-small">{{ "NO_DATA" | translate }}</span>
                  </div>
                </td>
              </tr>
            </table>
          }
          @if(showDiagnosticSubs) {
            <table mat-table [dataSource]="diagSubResponse"
              class="min-w-full mt-[1.6rem] !leading-[2.4rem]" aria-labelledby="diagnostic-subscriptions-table-caption">
              <caption id="diagnostic-subscriptions-table-caption" class="sr-only">List of subscriptions with details</caption>
              <ng-container matColumnDef="variantOfferId">
                <th mat-header-cell *matHeaderCellDef
                  class="text-center w-[8%] dsr-typescale-label-large-prominent max-sm:px-[2rem]">
                  {{ "SUBSCRIPTIONS_TABLE_HEAD_OFFER_ID" | translate }}
                </th>
                <td mat-cell *matCellDef="let item"
                  class="text-center first-letter:uppercase dsr-typescale-body-small max-sm:px-[2rem]">
                  {{ item.variantOfferId }}
                </td>
              </ng-container>
              <ng-container matColumnDef="variantOfferName">
                <th mat-header-cell *matHeaderCellDef
                  class="text-center dsr-typescale-label-large-prominent max-sm:px-[2rem]">
                  {{ "SUBSCRIPTIONS_TABLE_HEAD_OFFER_VARIANT" | translate }}
                </th>
                <td mat-cell *matCellDef="let item"
                  class="text-center first-letter:uppercase dsr-typescale-body-small max-sm:px-[2rem]">
                  {{ item.variantOfferName }}
                </td>
              </ng-container>
              <ng-container matColumnDef="durationType">
                <th mat-header-cell *matHeaderCellDef
                  class="text-center w-[8%] dsr-typescale-label-large-prominent max-sm:px-[2rem]">
                  {{ "SUBSCRIPTIONS_TABLE_HEAD_TYPE" | translate }}
                </th>
                <td mat-cell *matCellDef="let item"
                  class="text-center first-letter:uppercase dsr-typescale-body-small max-sm:px-[2rem]">
                  {{ item.durationType }}
                </td>
              </ng-container>
              <ng-container matColumnDef="price">
                <th mat-header-cell *matHeaderCellDef
                  class="text-center w-[8.5%] dsr-typescale-label-large-prominent  max-sm:px-[2rem]">
                  {{ "SUBSCRIPTIONS_TABLE_HEAD_PRICE" | translate }}
                </th>
                <td mat-cell *matCellDef="let item"
                  class="text-center first-letter:uppercase dsr-typescale-body-small break-all max-sm:px-[2rem]">
                  {{ item.price }}@if(item.price) {
                  <span>€</span>
                  }
                  @if(item.price == null) {
                  <span>-</span>
                  }
                </td>
              </ng-container>
              <ng-container matColumnDef="purchaseDate">
                <th mat-header-cell *matHeaderCellDef
                  class="text-center dsr-typescale-label-large-prominent max-sm:px-[2rem] required-label-r">
                  {{ "SUBSCRIPTIONS_TABLE_HEAD_START_DATE" | translate }}
                </th>
                <td mat-cell *matCellDef="let item"
                  class="text-center first-letter:uppercase dsr-typescale-body-small max-sm:px-[2rem]">
                  {{ item.purchaseDate }}@if(item.purchaseDate) {
                  <span>&nbsp;CET</span>
                  }
                  @if(item.purchaseDate == null) {
                  <span>-</span>
                  }
                </td>
              </ng-container>
              <ng-container matColumnDef="offerEndDate">
                <th mat-header-cell *matHeaderCellDef
                  class="text-center dsr-typescale-label-large-prominent max-sm:px-[2rem] required-label-r">
                  {{ "SUBSCRIPTIONS_TABLE_HEAD_END_DATE" | translate }}
                </th>
                <td mat-cell *matCellDef="let item"
                  class="text-center first-letter:uppercase dsr-typescale-body-small max-sm:px-[2rem]">
                  {{ item.offerEndDate }}@if(item.offerEndDate) {
                  <span>&nbsp;CET</span>
                  }
                  @if(item.offerEndDate == null) {
                  <span>-</span>
                  }
                </td>
              </ng-container>
              <ng-container matColumnDef="invoiceNumber">
                <th mat-header-cell *matHeaderCellDef
                  class="text-center dsr-typescale-label-large-prominent max-sm:px-[2rem]">
                  {{ "SUBSCRIPTIONS_TABLE_HEAD_INVOICE_NO" | translate }}
                </th>
                <td mat-cell *matCellDef="let item"
                  class="">
                  <div class="text-center first-letter:uppercase dsr-typescale-body-small max-sm:px-[2rem] break-all ">
                    {{ item.invoiceNumber }}@if(item.invoiceNumber == null) {
                    <span>-</span>
                    }
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="invoiceDate">
                <th mat-header-cell *matHeaderCellDef
                  class="text-center dsr-typescale-label-large-prominent max-sm:px-[2rem]">
                  {{ "SUBSCRIPTIONS_TABLE_HEAD_INVOICE_DATE" | translate }}
                </th>
                <td mat-cell *matCellDef="let item"
                  class="text-center first-letter:uppercase dsr-typescale-body-small max-sm:px-[2rem]">
                  {{ item.invoiceDate }}@if(item.invoiceDate) {
                  <span>&nbsp;CET</span>
                  }
                  @if(item.invoiceDate == null) {
                  <span>-</span>
                  }
                </td>
              </ng-container>
              <ng-container matColumnDef="paymentStatus">
                <th mat-header-cell *matHeaderCellDef
                  class="text-center w-[11%] dsr-typescale-label-large-prominent max-sm:px-[2rem]">
                  {{ "SUBSCRIPTIONS_TABLE_HEAD_STATUS" | translate }}
                </th>
                <td mat-cell *matCellDef="let item" class="text-center first-letter:uppercase dsr-typescale-body-small">
        
                  @if(item.paymentStatus == null) {
                    <span>-</span>
                  } @else {
                    <mat-chip [ngClass]="getPaymentStatusClass(item.paymentStatus)">
                  {{ item.paymentStatus | translate }}</mat-chip>
                  }
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="diagDisplayedColumns; sticky: true"
                class="first-letter:uppercase text-center"></tr>
              <tr mat-row *matRowDef="let row; columns: diagDisplayedColumns"
                class="text-center first-letter:uppercase dsr-typescale-body-small"></tr>
              <tr *matNoDataRow class="">
                <td [attr.colspan]="diagDisplayedColumns.length" class="text-center">
                  <div class="flex py-4 flex-col items-center text-light-dsr-color-secondary-container justify-end gap-[0.2rem]">
                    <svg width="17" height="21" viewBox="0 0 17 21" fill="currentColor" xmlns="http://www.w3.org/2000/svg"
                      alt="No-data found" class="button-icon !size-[40px]">
                      <path
                        d="M1.2 1.195H7.425V5.45H11.63V9.58H12.83V4L12.7 3.835C11.02 1.71 9.13 0.195 9.05 0.13L8.885 0H0V17.175H6.75V15.975H1.2V1.195ZM11.49 4.25H8.625V1.335C9.175 1.81 10.36 2.88 11.49 4.25ZM9.625 8.59H5.195V7.39H9.625V8.59ZM4.37 8.14C4.37 8.48 4.095 8.76 3.75 8.76H3.49C3.15 8.76 2.87 8.485 2.87 8.14V7.88C2.87 7.54 3.145 7.26 3.49 7.26H3.75C4.09 7.26 4.37 7.535 4.37 7.88V8.14ZM4.37 10.28C4.37 10.61 4.1 10.88 3.77 10.88H3.515C3.185 10.88 2.915 10.61 2.915 10.28V10.025C2.915 9.695 3.185 9.425 3.515 9.425H3.77C4.1 9.425 4.37 9.695 4.37 10.025V10.28ZM4.37 12.105V12.36C4.37 12.69 4.1 12.96 3.77 12.96H3.515C3.185 12.96 2.915 12.69 2.915 12.36V12.105C2.915 11.775 3.185 11.505 3.515 11.505H3.77C4.1 11.505 4.37 11.775 4.37 12.105ZM9.595 9.56V10.235L9.445 10.265C9.325 10.29 9.21 10.32 9.11 10.355C8.725 10.54 8.445 10.775 8.445 10.775H5.2V9.56H9.595ZM7.315 11.97C7.04 12.375 6.92 12.845 6.91 12.87C6.91 12.87 6.88 12.87 6.875 12.87H5.195V11.745H5.77L7.57 11.74L7.31 11.97H7.315ZM12.73 10.7H11.82C9.475 10.7 7.57 12.605 7.57 14.95V15.86C7.57 18.205 9.475 20.11 11.82 20.11H12.73C15.075 20.11 16.98 18.205 16.98 15.86V14.95C16.98 12.605 15.075 10.7 12.73 10.7ZM15.78 15.86C15.78 17.54 14.415 18.91 12.73 18.91H11.82C10.14 18.91 8.77 17.54 8.77 15.86V14.95C8.77 13.27 10.135 11.9 11.82 11.9H12.73C14.41 11.9 15.78 13.27 15.78 14.95V15.86Z"
                        fill="currentColor" />
                        <path
                          d="M11.0352 17.6289H9.91016L11.7282 15.3249L10.0452 13.1829H11.2422L12.3762 14.6319L13.5012 13.1829H14.6352L12.9342 15.3429L14.7252 17.6289H13.5282L12.2772 16.0359L11.0352 17.6289Z"
                          fill="currentColor" />
                    </svg>
                    <span class="dsr-typescale-body-small">{{ "NO_DATA" | translate }}</span>
                  </div>
              </td>
            </tr>
          </table>
              }
        </div>
      </div>
  </div>
</section>
  @if(subsLoading) {
    <div class="!absolute bg-opacity-75 backdrop-blur-sm z-40 top-1/2 right-1/2" role="status"
      aria-live="polite" aria-label="Loading subscriptions">
      <mat-progress-spinner class="!h-[50px] !w-[50px]" mode="indeterminate" />
    </div>
  }
</article>